import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "../../css/ShowRoom.css";

const InteriorDesignResidentialSelectionComponent = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [clickDelay, setClickDelay] = useState(null); // Track the timeout delay
  const sliderRef = useRef(null); // Reference to the slider instance
  const sliderContainerRef = useRef(null); // Reference to the slider container

  const isMouseInside = useRef(false); // Track if the mouse is inside the slider

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    focusOnSelect: true,

    beforeChange: (current, next) => {
      setPrevIndex(current);
      setCurrentIndex(next);
    },

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Determine the number of levels based on the current path
  const getBasePath = () => {
    const depth = window.location.pathname.split("/").length - 1;
    return "../".repeat(depth - 1); // Adjust `-1` based on your specific project structure
  };

  const basePath = getBasePath();

  const slides = [
    {
      id: 1,
      title: "DUAL ELEGANCE",
      description: "Where Modern Elegance Meets Timeless Comfort",
      image: `${basePath}Images/ResidentialImages/Dual-Elegance Living-Spaces.jpg`,
      link: "/interior-design/residential/dual-elegance",
    },
    {
      id: 2,
      title: "LIGHT AND SPACE",
      description: "Illuminating Transformations",
      image: `${basePath}Images/ResidentialImages/lightandspace.jpg`,
      link: "/interior-design/residential/light-and-space",
    },
    {
      id: 3,
      title: "HAVEN RESIDENCE",
      description: "A Perfect Blend of Style and Comfort.",
      image: `${basePath}Images/ResidentialImages/Haven-Residence.jpg`,
      link: "/interior-design/residential/haven-residence",
    },
    {
      id: 4,
      title: "LUXE RESIDANCE",
      description:
        "An exquisite harmony of classic charm and contemporary design",
      image: `${basePath}Images/ResidentialImages/Luxe-Residence.jpg`,
      link: "/interior-design/residential/luxe-residance",
    },
    {
      id: 5,
      title: "BEYSU MANSIONS",
      description: "Architecturally crafted for modern living",
      image: `${basePath}Images/ResidentialImages/Beysu-mansions.jpg`,
      link: "/interior-design/residential/beysu-mansions",
    },
    {
      id: 6,
      title: "MDR RESIDENCE",
      description:
        "A modern residential interior concept.. balanced style and practicality..",
      image: `${basePath}Images/ResidentialImages/Modern-Residence.jpg`,
      link: "/interior-design/residential/modern-residence",
    },
    {
      id: 7,
      title: "CONCEPTUAL PENTHOUSE",
      description:
        "A harmonious blend of textures, materials, and light, this conceptual penthouse design redefines modern luxury with a timeless touch.",
      image: `${basePath}Images/ResidentialImages/conceptual-penthouse.jpg`,
      link: "/interior-design/residential/conceptual-penthouse",
    },
    {
      id: 8,
      title: "IE HOUSE",
      description:
        "A blend of modern and traditional styles defines the design, balancing neutral tones with bold colors like deep blue.",
      image: `${basePath}Images/ResidentialImages/IEHOUSE.jpg`,
      link: "/interior-design/residential/ie-house",
    },
    {
      id: 9,
      title: "PRIVATE APARTMENT",
      description: "Open, bright living spaces with metallic art.",
      image: `${basePath}Images/ResidentialImages/privateapartment2.jpg`,
      link: "/interior-design/residential/private-apartment",
    },
    {
      id: 10,
      title: "SINPAS RESIDENCES",
      description:
        "A seamless fusion of modern sophistication and functional elegance",
      image: `${basePath}Images/ResidentialImages/Sinpas-Residences.jpg`,
      link: "/interior-design/residential/sinpas-residences",
    },
  ];

  // Handle smooth transition timing for description
  useEffect(() => {
    if (prevIndex !== null) {
      const timeout = setTimeout(() => {
        setPrevIndex(null);
      }, 800);
      return () => clearTimeout(timeout);
    }
  }, [prevIndex]);

  const handleMouseDown = () => {
    setClickDelay(
      setTimeout(() => {
        setClickDelay(null);
      }, 200)
    );
  };

  const handleClick = (link) => {
    if (clickDelay) {
      if (link) {
        window.location.href = link;
      }
    }
  };

  // Scroll and arrow key navigation
  useEffect(() => {
   
  
    const handleWheel = (event) => {
      if (isMouseInside.current && sliderRef.current) {
        event.preventDefault(); // Prevent page scroll
        if (event.deltaY > 0) {
          sliderRef.current.slickNext();
        } else {
          sliderRef.current.slickPrev();
        }
      }
    };

        // Only add the event listener when mouse is inside slider container
        const sliderContainer = sliderContainerRef.current;
        if (sliderContainer) {
          sliderContainer.addEventListener("wheel", handleWheel, { passive: false });
        }
    
  

    // Function to handle arrow key navigation
    const handleKeyDown = (event) => {
      
      if (isMouseInside.current && sliderRef.current) {
        if (event.key === "ArrowRight") {
          sliderRef.current.slickNext(); // Right arrow key moves to next slide
        } else if (event.key === "ArrowLeft") {
          sliderRef.current.slickPrev(); // Left arrow key moves to previous slide
        }
      }
    };

    // Attach event listeners to the window
   
    if (sliderContainer) {
    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("keydown", handleKeyDown, { passive: false });
  }
    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Runs only once when the component mounts

  // Optional: Automatically focus the slider container on load
  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.innerSlider.list.focus();
    }
  }, []);

  return (
    <>
      <div className="slider-container"
        ref={sliderContainerRef}
        onMouseEnter={() => (isMouseInside.current = true)}
        onMouseLeave={() => (isMouseInside.current = false)}
      >
        {/* Image Container */}
        <div className="image-container">
          {slides.map((slide, index) => {
            let className = "main-image";
            if (index === currentIndex) {
              className += " active";
            } else if (index === prevIndex) {
              className += " outgoing";
            }

            return (
              <img
                key={slide.id}
                src={slide.image}
                alt={slide.title}
                className={`${className} ${
                  index === currentIndex && prevIndex !== null ? "incoming" : ""
                }`}
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundSize: "cover",
                  objectFit: "cover",
                }}
              />
            );
          })}
        </div>

        {/* Description text in a div */}
        <div
          className={`description-container ${
            prevIndex !== null ? "outgoing-text" : ""
          } ${currentIndex !== prevIndex ? "incoming-text" : ""} ${
            currentIndex === prevIndex ? "active-text" : ""
          }`}
        >
          <p className="description-text">{slides[currentIndex].description}</p>
        </div>

        {/* Titles Slider */}
        <Slider ref={sliderRef} {...sliderSettings} className="slider">
          {slides.map((slide, index) => (
            <div key={slide.id} className="slide">
              <div
                className={`slide-title ${
                  index === currentIndex ? "active-title" : ""
                }`}
                onMouseDown={handleMouseDown} // Start the delay on mouse down
                style={{
                  fontSize: "24px", // Bigger font
                  fontWeight: "bold",
                  textAlign: "center",
                  cursor: slide.link ? "pointer" : "default", // Show pointer if navigable
                }}
              >
                <p
                  onClick={() => handleClick(slide.link)}
                  style={{
                    fontSize: "50px",
                  }}
                >
                  {slide.title}
                </p>{" "}
                {/* Wrap title with <p> tag */}
              </div>
            </div>
          ))}
        </Slider>

        {/* Clickable list at the bottom */}
       
      </div>
      <div className="slides-list">
        {slides.map((slide) => (
          <div
            key={slide.id}
            className="list-item"
            onClick={() => (window.location.href = slide.link)}
          >
            {slide.title}
          </div>
        ))}
      </div>
    </>
  );
};

export default InteriorDesignResidentialSelectionComponent;
